import { useEffect, useState } from "react";
import { Logo } from "./Logo";
import { WaButton } from "./ui";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-40 bg-white/95 backdrop-blur-md transition-shadow duration-300 ${scrolled ? "shadow-[0_2px_20px_rgba(11,60,93,.08)]" : ""}`}>
      <div className="mx-auto flex max-w-6xl flex-col items-stretch gap-2.5 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-2 sm:px-6">
        <a href="/" aria-label="Plan Isapre Contigo, inicio" data-testid="header-logo-link" className="min-w-0"><Logo /></a>
        <WaButton testId="header-cta-btn" className="!min-h-[46px] w-full shrink-0 !text-[16px] sm:w-auto sm:!px-5 [&>svg]:!h-5 [&>svg]:!w-5" label="Quiero asesorarme" />
      </div>
    </header>
  );
};
